var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-home",class:_vm.isDialog?'ispc':'ismobile'},[_vm._m(0),_c('applyForm')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-container"},[_c('div',{staticClass:"submit-head"},[_c('img',{staticClass:"form-head",attrs:{"src":require("@/assets/images/formHead@2x.png"),"alt":"","srcset":""}})])])
}]

export { render, staticRenderFns }